import React, {useMemo, useRef, useState} from "react";
import PropTypes from 'prop-types';
import {Tooltip} from "reactstrap";
import {ErrorBoundary} from "react-error-boundary";


const zoomFactor = 0.9;
const InfoTooltip = ({tooltipProps = {},...props}) => {
    const [isOpen,setOpen] = useState(false);
    const [targetId, setTargetId] = useState("tooltip" + TB.guid());

    const containerRef = useRef(null);
    const iconStyle = useMemo(() => {
        let iconStyle = props.iconStyle || {};
        if(props.iconSize) {
            iconStyle.fontSize = props.iconSize;
        }
        if(props.iconColor) {
            iconStyle.color = props.iconColor;
        }
        return iconStyle;
    }, [props.iconSize, props.iconColor]);

    // const modifiers = {
    //     offset: {
    //         gpuAcceleration: false, // Disable GPU acceleration
    //         fn(pop) {
    //             // Adjust the offset based on the zoom factor
    //             // const { state } = pop || {};
    //             let state = {...pop}
    //             console.log('fn', state);
    //
    //             let offsets = {}
    //
    //             TB.map(state.offsets.reference, (value, key) => {
    //                 offsets[key] = value/zoomFactor;
    //             })
    //             let poffsets = {}
    //
    //             TB.map(state.offsets.popper, (value, key) => {
    //                 poffsets[key] = value/zoomFactor;
    //             })
    //             state.offsets.reference = offsets;
    //             state.offsets.popper = poffsets;
    //             return state
    //         },
    //         enabled: true
    //     },
    //     // computeStyles: {
    //     //     enabled: true,
    //     //     phase: 'beforeWrite',
    //     //     requires: ['computeStyles'],
    //     //     fn(pop) {
    //     //         // Adjust the offset based on the zoom factor
    //     //         // const { state } = pop || {};
    //     //         let state = {...pop}
    //     //         console.log('fn', state.offsets);
    //     //
    //     //         state.offsets.popper.top = state.offsets.popper.top / zoomFactor;
    //     //         state.offsets.popper.left = state.offsets.popper.left / zoomFactor;
    //     //         return state
    //     //     },
    //     // }
    // }
    // useMount(() =>{
    //     if (document.getElementsByClassName('talent-scaling')) {
    //         console.log('InfoTooltipusiong modifier')
    //     }
    // })
    // if (props.target && !document.getElementById(props.target)) {
    //     return null;
    // }
    return (
        <ErrorBoundary fallback={null}>
            <span className={"tooltip-info"} ref={containerRef}>
                {!props.target && (
                    <span id={targetId} href={"#"}>
                        <i className="fa fa-info-circle" style={iconStyle}/>
                    </span>
                )}

                {(props.target || targetId) && (
                    <Tooltip placement={props.placement || 'top'}
                             container={containerRef.current}
                             target={props.target || targetId}
                        // modifiers={document.getElementsByClassName('talent-scaling')?.length > 0 ? modifiers : undefined}
                             arrowClassName={props.type || 'primary'}
                             innerClassName={props.type || 'primary'}
                             isOpen={isOpen}
                             autohide={false}
                             toggle={() => setOpen(!isOpen)}
                             {...tooltipProps}
                    >

                        {props.children}

                    </Tooltip>
                )}

            </span>
        </ErrorBoundary>
    )
};
export default InfoTooltip;

InfoTooltip.propTypes = {
    target: PropTypes.string,
    placement: PropTypes.string,
    type: PropTypes.string,
    iconSize: PropTypes.number,
    iconStyle: PropTypes.any,
    iconColor: PropTypes.any,
    children: PropTypes.any,
};